import { defineComponent } from 'vue'
import type { CodeBlockProps } from './types'

const CodeBlock = defineComponent<CodeBlockProps>({
  setup(props) {
    return () => {
      return (
        <pre
          class="pretty-scrollbar light"
          style={{
            background: 'rgb(48, 48, 48)',
            color: 'white',
            padding: '1rem',
            minWidth: '1rem',
            minHeight: '1rem',
            maxHeight: '100%',
            overflowY: 'auto',
            ...(props.resizable
              ? {
                  resize: 'both'
                }
              : {})
          }}
        >
          {props.value || 'e'}
        </pre>
      )
    }
  }
})

CodeBlock.props = ['value', 'resizable']

export default CodeBlock
